import { useAuthUserStore } from "@/stores/authUser";

export default function hasRCUser() {
    const authUserStore = useAuthUserStore();
    const u = authUserStore.user;
    if (!u.related.rcuser) {
        return {
            name: "library.community"
        };
    }
}
